<template>
  <router-link :to="{ name: routeName }">
    <v-sheet
      rounded
      color="transparent"
      :min-height="itemHeight"
      class="my-1 text-body-2 rounded-xl mx-4 wrapper"
      :class="{ open }">
      <v-sheet
        :min-height="itemHeight"
        rounded
        color="transparent"
        class="menu-item pl-4 pr-0 py-0 relative d-flex align-center font-weight-medium rounded-xl"
        :class="{
          'active': isActive,
          'has-children': hasChildren,
          'sub-item': subItem,
          'grey--text text--lighten-5': !isActive && $store.state.darkMode,
          'text--text text--darken-4': !isActive && !$store.state.darkMode,
          dark: $store.state.darkMode,
        }"
        v-ripple>
        <v-icon v-if="!hideIcon" left size="18">
          {{ item.icon }}
        </v-icon>

        <span class="px-1">{{ item.label }}</span>

        <v-btn
          v-if="hasChildren"
          icon
          tile
          right
          class="ml-auto rounded-lg"
          @click.native.prevent="toggle">
          <v-icon> mdi-chevron-down </v-icon>
        </v-btn>
      </v-sheet>

      <v-sheet
        v-if="hasChildren"
        :class="{ open }"
        :style="{
          height: childrenHeight,
        }"
        class="children"
        color="transparent">
        <div class="py-2">
          <sidebar-menu-item
            v-for="(item, index) in item.children"
            :key="'sidebar-menu-item-' + index"
            :item="item"
            hide-icon
            sub-item />
        </div>
      </v-sheet>
    </v-sheet>
  </router-link>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => { },
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    subItem: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      open: false,
    };
  },

  methods: {
    matchRoute(name) {
      if (!name) {
        return false;
      }
      return !!this.$route.matched.filter((e) => e.path && e.name === name).length;
    },

    matchChildRoute(name) {
      return !!this.$route.matched.filter((e) => e.path && e.name === name).length;
    },

    toggle() {
      this.open = !this.open;
    },
  },

  computed: {
    itemHeight() {
      return 36;
    },

    isActive() {
      return this.item.children?.length
        ? this.matchRoute(this.item.group)
        : this.matchRoute(this.item.to?.name);
    },

    routeName() {
      if (this.item.type === 'heading') {
        return false;
      }
      if (this.item?.to?.name) {
        return this.item.to.name;
      } else {
        return this.item.children[0].to.name;
      }
    },

    hasChildren() {
      return !!this.item.children?.length;
    },

    childrenHeight() {
      return this.open ? this.item.children.length * (this.itemHeight + 4) + 20 + 'px' : '0px';
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-item {
  transition: 0.25s all;
  font-size: 14px !important;

  &.active {
    // font-weight: 800 !important;
    font-variation-settings: "wght" 600, "wdth" 200 !important;
  }

  &.active:not(.has-children) {
    background-color: var(--v-primary-base) !important;
    color: #fff;

    &.theme--dark {
      color: #000 !important;
    }

    & .v-icon {
      color: #fff !important;

      &.theme--dark {
        color: #000 !important;
      }
    }
  }

  &:hover {
    background-color: #8882 !important;
  }
}

.has-children.active {
  // background: transparent !important;
  background-color: #8882 !important;
  color: #000 !important;

  &.dark {
    // background-color: #333 !important;
    color: #fff !important;
  }
}

.wrapper {
  transition: 200ms all;
  transition-delay: 200ms;
}

.wrapper.open {
  background-color: #8882 !important;
  transition-delay: 0ms !important;
}

.sub-item {
  position: relative !important;
}

.children {
  position: relative;
  transition: 200ms opacity, 200ms height, 400ms transform;
  transition-delay: 100ms, 0ms, 0ms;
  overflow-y: hidden;
  opacity: 0;
  transform: translateY(5px) scaleX(0.98);
  transform-origin: top center;

  &.open {
    opacity: 1;
    transform: translateY(0);
  }

  // &::before {
  //   content: '';
  //   position: absolute;
  //   width: 2px;
  //   left: 4px;
  //   top: 4px;
  //   bottom: 4px;
  //   background-color: var(--v-primary-base);
  // }
}
</style>
